
  <div class="amplify-authenticator">
    <amplify-auth-sign-in-core
      *ngIf="!shouldHide('SignIn')"
      [authState]="authState"
      [usernameAttributes]="_usernameAttributes"
      [hide]="hide"
    ></amplify-auth-sign-in-core>

    <amplify-auth-sign-up-core
      *ngIf="!shouldHide('SignUp')"
      [authState]="authState"
      [signUpConfig]="_signUpConfig"
      [usernameAttributes]="_usernameAttributes"
      [hide]="hide"
    ></amplify-auth-sign-up-core>

    <amplify-auth-confirm-sign-up-core
      *ngIf="!shouldHide('ConfirmSignUp')"
      [authState]="authState"
      [usernameAttributes]="_usernameAttributes"
      [hide]="hide"
    ></amplify-auth-confirm-sign-up-core>

    <amplify-auth-confirm-sign-in-core
      *ngIf="!shouldHide('ConfirmSignIn')"
      [authState]="authState"
      [hide]="hide"
    ></amplify-auth-confirm-sign-in-core>

    <amplify-auth-forgot-password-core
      *ngIf="!shouldHide('ForgotPassword')"
      [authState]="authState"
      [usernameAttributes]="_usernameAttributes"
      [hide]="hide"
    ></amplify-auth-forgot-password-core>

    <amplify-auth-greetings-core
    *ngIf="!shouldHide('Greetings')"
    [authState]="authState"
    [usernameAttributes]="_usernameAttributes"
    ></amplify-auth-greetings-core>

     <amplify-auth-require-new-password-core
      *ngIf="!shouldHide('RequireNewPassword')"
      [authState]="authState"
      [hide]="hide"
    ></amplify-auth-require-new-password-core>
  </div>



// WEBPACK FOOTER //
// ./node_modules/aws-amplify-angular/dist/src/components/authenticator/authenticator/authenticator.component.core.d.ts.AuthenticatorComponentCore.html